<template>
  <section class="section">
    <div class="container">
      <div class="title is-3 has-text-centered">{{ $t("my courses") }}</div>
      <div class="columns">
        <div class="column">
          <generic-dropdown
            :title="$t('select program and period')"
            :placeholder="$t('select one')"
            url="/student-portal/student/inscription/catalog"
            :display_function="
              (
                item
              ) => `<div class='title is-6'>${item.program.name} - ${item.period.name}</div>
            <div class='subtitle is-6'>${item.stage.name}</div>`
            "
            value_field="inscription_id"
            @selected="set_inscription"
            ref="inscription_dropdown"
            :is_multiple="false"
          />
        </div>
        <div class="column is-narrow">
          <label class="label"> {{ $t("options") }} </label>
          <div class="buttons">
            <div class="button is-info" @click="clear_inscription">
              <span class="icon">
                <i class="fa fa-eraser"></i>
              </span>
              <span>{{ $t("clear") }}</span>
            </div>
            <div class="button" @click="go_back">
              <span class="icon">
                <i class="fa fa-angle-left"></i>
              </span>
              <span>{{ $t("back") }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selected_inscription">
        <inscription-courses ref="inscription_courses" />
      </div>
    </div>
  </section>
</template>

<script>
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import InscriptionCourses from "./InscriptionCourses.vue";

export default {
  name: "StudentCoursesDashboard",
  components: { GenericDropdown, InscriptionCourses },
  data() {
    return {
      selected_inscription: null,
    };
  },
  computed: {},
  methods: {
    set_inscription(inscription) {
      let v = this;
      v.selected_inscription = inscription;
      setTimeout(() => {
        if (inscription && v.$refs.inscription_courses)
          v.$refs.inscription_courses.set_inscription(inscription);
      }, 200);
      // this.inscription = inscription;
      // this.$refs.inscription_dropdown.clear();
      // this.$refs.inscription_dropdown.set_value(inscription.inscription_id);
    },
    clear_inscription() {
      let v = this;
      v.$refs.inscription_dropdown.clear();
      v.selected_inscription = null;
    },
    go_back() {
      let v = this;
      v.$router.push({
        path: "/student-portal",
      });
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
